module.exports = __webpack_public_path__ + "media/images/homepage/bg-contact-e8aab76f30564a8eed35c5f6f48c2e46.png";